import React from 'react';
import * as api from '../../../stores/api';
import CaseProgress from '../../shared/CaseProgress';
import Modal from '../../shared/Modal';
import imeStore from './IMEStore';

function ModalCaseProgress() {
  const { open, modalParams, toggleModal } = imeStore;
  const title = `Case Progress: ${modalParams.caseNo}`;
  const url = '/MedicalService/GetAssessmentLogs';
  const body = { assessmentId: modalParams.id };

  return (
    <Modal visible={open} onCancel={toggleModal(false)} width={1450} title={title}>
      <CaseProgress progressList={api.IME_CaseProgress.data.itemList} url={url} body={body} />
    </Modal>
  );
}

export default ModalCaseProgress;
